/**
 * haveibeenpwned-error-codes
 * Adapted from @daveyplate/better-auth-ui
 * Enhanced for @bettercone/ui
 */

export const HAVEIBEENPWNED_ERROR_CODES = {
    PASSWORD_COMPROMISED:
        "The password you entered has been compromised. Please choose a different password."
}
